import { render, staticRenderFns } from "./Offers1CInvoice.vue?vue&type=template&id=b1790fc0&"
import script from "./Offers1CInvoice.vue?vue&type=script&lang=ts&"
export * from "./Offers1CInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports